import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import PanelFactory from '../../app/panel-factory';
import Signals from 'signals';
import DataProvider from '../../app/data-framework/data-provider';
import PermissionService from '../../services/permission.service';
import templateMarkup from 'raw-loader!./addpanel-modal.html';
import LoginService from "../../services/login.service";

function AddpanelModal(params) {
    var self = this;

    self.filter = params.filter === 'historical2roomboard' ? 'historical2dashboard' : params.filter;
    self.callback = params.callback;
    self.addedPanels = params.addedPanels;
    self.dataProvider = DataProvider.getInstance();
    self.permissionService = new PermissionService(LoginService.userObject);

    self.isDarkMode = ko.observable(document.body.classList.contains('dark'));

    let lastClassString = document.body.classList.toString();

    self.observer = new MutationObserver((mutationList) => {
      for (const item of mutationList) {
        if (item.attributeName === "class") {
          const classString = document.body.classList.toString();
          if (classString !== lastClassString) {
            self.isDarkMode(document.body.classList.contains('dark'));
            lastClassString = classString;
            break;
          }
        }
      }
    });

    self.observer.observe(document.body, { attributes: true });
  
  
    self.countsDict = ko
        .pureComputed(function () {
            var result = {};
            self.addedPanels()
                .forEach(function (dashboardDataItem) {
                    if (!result[dashboardDataItem.componentType]) {
                        result[dashboardDataItem.componentType] = 0;
                    }
                    result[dashboardDataItem.componentType]++;
                });
            return result;
        })
        .extend({ notify: 'always' });

    self.panels = ko.observableArray();

    self.panelFactory = new PanelFactory();
    self.panelFactory
        .getFilteredPanelsListPromise()
        .then(function (panelsArg) {
            var panels = _
                .chain(_.get(panelsArg, self.filter, []))
                .filter(Boolean) /*filter out undefined panels*/
                .map(function (panel) {
                    var panelOptions = _.get(panel, 'defaultOptions', {});
                    panel.optionsmodalopen = ko.observable(false);

                    panel.params = {
                        widgetParams: {
                            dataProvider: self.dataProvider,
                            observableOptions: ko.observable(panelOptions),
                            panelTemplate: panel
                        },
                        widgetSignals: {
                            optionsPanelApply: new Signals.Signal(),
                            optionsPanelClose: new Signals.Signal(),
                            optionsPanelOpen: new Signals.Signal()
                        },
                        id: 'addpaneloptionfor' + panel.panelType
                    };

                    panel.params.widgetSignals.optionsPanelApply.add(function () {
                        self.addPanelWithOptions(panel);
                        removePanelOptionsModal(panel.params.id);
                    });

                    panel.params.widgetSignals.optionsPanelClose.add(function () {
                        removePanelOptionsModal(panel.params.id);
                    });

                    return panel;
                })
                .value();

            self.panels(panels);
        });

    // Methods - Added in the constructor so that they can retain their execution context. These are used
    // in the knockout:foreach context so the 'this' reference is reassigned. To preserve that we use the 'self'
    // pattern and a closure.
    self.addPanel = function (panel) {
        var cleaneduppanel = cleanupPanel(panel);
        self.dataProvider.logActivity2('addingPanel', '', '', { panel: cleaneduppanel });
        if (self.callback) {
            self.callback(cleaneduppanel);
        }
    };
    self.addPanelWithOptions = function (panel) {
        var cleaneduppanel = cleanupPanel(panel);
        self.dataProvider.logActivity2('addingPanel', '', '',
            { panel: cleaneduppanel, options: panel.params.widgetParams.observableOptions() }
        );
        if (self.callback) {
            self.callback(cleaneduppanel, panel.params.widgetParams.observableOptions());
        }
    };
    self.setOptions = function (panel) {
        var htmlEl = $('#' + panel.params.id);
        // Add new options modal, tag it with a class to ease disposal later
        $('body').prepend(htmlEl.addClass('addpanel-modal-options-modal'));
        htmlEl.css('zIndex', 1100);
        htmlEl.modal('show');
        if (panel.params) {
            if (panel.params.widgetParams.observableOptions){
                let options = resetOptions(panel.params.widgetParams.observableOptions());
                panel.params.widgetParams.observableOptions(options);
            }
            if (panel.params.widgetSignals.optionsPanelOpen){
                panel.params.widgetSignals.optionsPanelOpen.dispatch();
            }
        }
    };
}

AddpanelModal.prototype = {
    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    dispose: function() {
        // Clean up all panel option modals that were prepended to the body
        $('body > .addpanel-modal-options-modal').remove();
      if (this.observer) { this.observer.disconnect(); }
    }
};

function resetOptions(options) {
    return {
      pageNum: options.pageNum,
      pageSize: options.pageSize,
      panelFilters: options.panelFilters,
      panelHeader: '',
      resize: options.resize,
      sortAsc: options.sortAsc,
      sortIndex: options.sortIndex,
      type: options.type
    };
}

function cleanupPanel(panelWParams) {
    let panelResult = $.extend(true, {}, panelWParams);
    delete panelResult.params;
    return panelResult;
}

function removePanelOptionsModal(id) {
    var optionsModal = $('#' + id);
    optionsModal.modal('hide');
    $('#optionsComp' + id).prepend(optionsModal);
}

export default { template: templateMarkup, viewModel: AddpanelModal };
